// extracted by mini-css-extract-plugin
export var adjacentSlide = "_sm-9";
export var arrowButtonContainer = "_sm-5";
export var arrowButtonIcon = "_sm-6";
export var carouselArrowButton = "_sm-2";
export var carouselElementContainer = "_sm-1";
export var currentSlide = "_sm-8";
export var left = "_sm-3";
export var otherSlide = "_sm-a";
export var productCarouselContainer = "_sm-0";
export var right = "_sm-4";
export var sliderOverflow = "_sm-7";